import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromStore from '@app/auth/store';
import { Login, Forgot } from '@app/auth/store/actions/auth.actions';
import { Authenticate } from '@app/auth/models/authentication.model';

@Component({
  selector: 'app-forgot-page',
  template: `
    <app-auth-wrapper>
      <div auth-form>
        <app-forgot-form (submitted)="onForgot($event)"></app-forgot-form>
      </div>
    </app-auth-wrapper>
  `,
  styles: [``]
})
export class ForgotPageComponent implements OnInit {
  error$ = this.store.select(fromStore.selectLoginPageError);
  pending$ = this.store.select(fromStore.selectLoginPagePending);

  constructor(private store: Store<fromStore.State>) {}

  ngOnInit() {}

  onForgot(credentials: Authenticate) {
    this.store.dispatch(new Forgot(credentials));
  }
}
